import { render, staticRenderFns } from "./RenameAreaDialog.vue?vue&type=template&id=255cf30a&scoped=true&"
import script from "./RenameAreaDialog.vue?vue&type=script&lang=js&"
export * from "./RenameAreaDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "255cf30a",
  null
  
)

export default component.exports